<ng-container *ngIf="userType === 'internal'">
  <app-users-registry-requests-list-internal></app-users-registry-requests-list-internal>
</ng-container>


<ng-container *ngIf="userType === 'external'">
  <app-users-registry-requests-list-external></app-users-registry-requests-list-external>
</ng-container>
